import { NAV_PATHS } from '@modules/common/constants';

const ARTEFACT_PATHS = [
  NAV_PATHS.QUANTIFY,
  NAV_PATHS.DASHBOARD,
  NAV_PATHS.SEARCH,
  NAV_PATHS.FEED,
  NAV_PATHS.COLLECTION,
  NAV_PATHS.RECORD,
];

export const isSavedArtefactOrRecordPathname = (pathname: string) => {
  const validPathsPattern = new RegExp(
    `\\/(${ARTEFACT_PATHS.join('|')})\\/\\w+`,
  );

  return validPathsPattern.test(pathname);
};
